import { Component, Injector, Input } from '@angular/core';
import { splitLines } from '../../../../../submodules/common/util'
import { encodeValueForInput } from '../../angular-common/util';
import { BaseView } from '../base-view';
import { Descriptor } from './data-importer-descriptor/data-importer-descriptor.component';

@Component({
  selector: 'app-data-importer',
  templateUrl: './data-importer.component.html',
  styleUrls: ['./data-importer.component.scss']
})
export class DataImporterComponent extends BaseView {

  /**
   * Descrittore del csv, colonna per colonna
   */
  @Input() descriptor: {[index: number]: Descriptor};
  data;

  constructor(protected _injector: Injector) {
    super(_injector)
  }

  process(input){
    const reader = new FileReader();
    reader.addEventListener('load', (event: any)=> populateData(event.target.result, input.separator, input.headerPresent))
    reader.readAsText(input.file, 'utf8');

    const populateData = (input, separator, headerPresent) => {
      let lines = splitLines(input)
      if(headerPresent)
        lines = lines.slice(1)
      this.data = encodeValueForInput(lines.map((el,i)=>{
        const row = el.split(separator=='comma'?',':';')
        let result = {id: i};
        Object.keys(this.descriptor).forEach(el => {
          result[this.descriptor[el].targetField]=row[el]
        });
        return result;
      }))
    }
  }
}

